import posthog from 'posthog-js'
import { browser } from '$app/environment';

// let ssr = false
export async function load(p) {
  if (browser) {
    posthog.init(
      'phc_BQxWF3dO2N7w5Cv3CK7yOVCOv82a6OFJLIVd5hDIU2D',
      {
        api_host: 'https://d3bgpntsyxdbq.cloudfront.net',
        ui_host: 'https://eu.posthog.com',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      }
    )
  }
  return p.data
}
